import { motion } from "framer-motion";
import { Cpu, Zap, Droplets, MessagesSquare, ArrowRight } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";
import { scrollToId } from "@/lib/scroll";

const TILES = [
  { id: "steuerung", span: "md:col-span-2 md:row-span-2", img: "/images/geschichte.png", icon: Cpu, k: "Intelligente Technik", t: "Individuelle Poolsteuerung", d: "In unserem Haus entwickelt – maßgeschneidert auf Ihre Anforderungen und Ihr Projekt." },
  { id: "elektrik", span: "", img: "/images/verteilerkasten.jpg", icon: Zap, k: "Integrierte Elektrik", t: "Technik & Strom aus einem Guss", d: "Pooltechnik und Elektroinstallation optimal aufeinander abgestimmt." },
  { id: "wasser", span: "", img: "/images/wasser-ok.jpg", icon: Droplets, k: "Wasserqualität", t: "Kristallklar & türkis", d: "Perfekt aufbereitetes Wasser für ungetrübten Badegenuss." },
  { id: "beratung", span: "md:col-span-2", img: "/images/beratung-am-pool.jpg", pos: "object-[30%_center]", icon: MessagesSquare, k: "Persönliche Beratung", t: "Von der Planung bis zur Inbetriebnahme", d: "Wir begleiten Sie auf jedem Schritt." },
];

const Tile = ({ tile, i }) => (
  <Reveal delay={i * 0.07} className={`${tile.span} min-h-[320px]`}>
    <motion.article whileHover="hover" data-testid={`bento-tile-${tile.id}`} className="group relative h-full overflow-hidden rounded-[28px] border border-white/10 bg-[var(--deep)]">
      <motion.img variants={{ hover: { scale: 1.06 } }} transition={{ duration: 1.2, ease: [0.16, 1, 0.3, 1] }} src={tile.img} alt={tile.t} className={`absolute inset-0 h-full w-full object-cover opacity-70 ${tile.pos || ""}`} />
      <div className="absolute inset-0 bg-gradient-to-t from-[#04171B] via-[#04171B]/60 to-[#04171B]/10" />
      <div className="relative flex h-full flex-col justify-between p-6 sm:p-8">
        <span className="flex h-11 w-11 items-center justify-center rounded-full border border-white/20 bg-[rgba(4,23,27,0.5)] backdrop-blur text-[var(--lagoon)]"><tile.icon className="h-5 w-5" /></span>
        <div>
          <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-[var(--lagoon)]">{tile.k}</p>
          <h3 className="mt-2 font-display text-2xl sm:text-3xl font-medium tracking-[-0.02em]">{tile.t}</h3>
          <p className="mt-2 max-w-md text-sm sm:text-base text-[var(--mist)]">{tile.d}</p>
        </div>
      </div>
    </motion.article>
  </Reveal>
);

export const Bento = () => (
  <section id="technik" data-testid="technik-section" className="mx-auto max-w-[1400px] px-5 py-24 sm:px-8 sm:py-32">
    <Reveal><Eyebrow>Die Technik hinter REVIVO-Smartpool</Eyebrow></Reveal>
    <Reveal delay={0.08}>
      <h2 className="mt-6 max-w-4xl font-display text-4xl sm:text-5xl lg:text-6xl font-semibold leading-[1] tracking-[-0.03em]">Vier Bausteine. <span className="text-[var(--lagoon)]">Ein System.</span></h2>
    </Reveal>
    <div className="mt-14 grid grid-cols-1 gap-4 md:grid-cols-3 md:auto-rows-[320px]">
      {TILES.map((t, i) => <Tile key={t.id} tile={t} i={i} />)}
      <Reveal delay={0.3} className="min-h-[320px]">
        <button data-testid="bento-cta-tile" onClick={() => scrollToId("pool-check")} className="group flex h-full w-full flex-col justify-between rounded-[28px] bg-[var(--lagoon)] p-6 sm:p-8 text-left text-[#04171B] transition-transform duration-500 hover:-translate-y-1">
          <span className="font-mono text-[11px] uppercase tracking-[0.25em]">Kostenlos · unverbindlich</span>
          <span>
            <span className="block font-display text-3xl font-semibold leading-tight tracking-[-0.02em]">Welche Technik passt zu Ihrem Pool?</span>
            <span className="mt-4 inline-flex items-center gap-2 font-medium">Pool-Check starten <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" /></span>
          </span>
        </button>
      </Reveal>
    </div>
  </section>
);
